/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteRoleInput = {|
  id: string,
  csrfToken?: ?string,
  socketClientId?: ?string,
  clientMutationId?: ?string,
|};
export type deleteRoleMutationVariables = {|
  input: DeleteRoleInput
|};
export type deleteRoleMutationResponse = {|
  +deleteRole: ?{|
    +deletedRoleId: ?string,
    +errors: ?$ReadOnlyArray<?string>,
  |}
|};
export type deleteRoleMutation = {|
  variables: deleteRoleMutationVariables,
  response: deleteRoleMutationResponse,
|};
*/


/*
mutation deleteRoleMutation(
  $input: DeleteRoleInput!
) {
  deleteRole(input: $input) {
    deletedRoleId
    errors
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteRoleInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteRolePayload",
    "kind": "LinkedField",
    "name": "deleteRole",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedRoleId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errors",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteRoleMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deleteRoleMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "deleteRoleMutation",
    "operationKind": "mutation",
    "text": "mutation deleteRoleMutation(\n  $input: DeleteRoleInput!\n) {\n  deleteRole(input: $input) {\n    deletedRoleId\n    errors\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '512aeaf8a5f2f9d8b758a578e043538e';

module.exports = node;
